export enum WeekendDay {
  Saturday = 6,
  Sunday = 0,
}
